export default "__VITE_ASSET__IiWAv90J__"